export type BuyerProfileUi = {
  buyerId?: string;
  title: string;
};

export const initialState: BuyerProfileUi = {
  title: '',
};
